import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import TauriBreadCrumbDropdown from "../TauriBreadcrumbDropdown";

const TauriCyclePeriodDropdown = ({ onDateChange }) => {
  const cyclePeriods = [
    "CP1",
    "CP2",
    "CP3",
    "CP4",
    "CP5",
    "CP6",
    "CP7",
    "CP8",
    "CP9",
    "CP10",
    "CP11",
    "CP12",
    "CP13",
  ];

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();
  const numberOfYears = 2;

  const years = [];
  for (let i = currentYear - numberOfYears; i <= currentYear; i++) {
    years.push(i);
  }

  const getInitialValue = (key, defaultValue) =>
    parseInt(localStorage.getItem(key), 10) || defaultValue;

  const getFullYear = (date) => new Date(date).getFullYear();

  const cyclePeriodCode = getInitialValue(
    "c_cd",
    cyclePeriods[currentMonthIndex],
  );

  const cyclePeriodFromYear = getFullYear(localStorage.getItem("c_str"))

  const [selectedDates, setSelectedDates] = useState({
    CycleCode: getInitialValue("CycleCode", cyclePeriodCode),
    CycleYear: getInitialValue("CycleYear", cyclePeriodFromYear),
  });

  useEffect(() => {
    localStorage.setItem("CycleCode", selectedDates.CycleCode);
    localStorage.setItem("CycleYear", selectedDates.CycleYear);
    onDateChange({
      CycleCode: selectedDates.CycleCode,
      CycleYear: selectedDates.CycleYear,
    });
  }, [selectedDates]);

  useEffect(() => {
    onDateChange(selectedDates);
  }, []);

  const cyclePeriodItems = cyclePeriods.map((cyclePeriod) => ({
    label: cyclePeriod.toString(),
    value: cyclePeriod,
  }));

  const yearItems = years.map((year) => ({
    label: year.toString(),
    value: year,
  }));

  return (
    <>
      <div className="label-date mx-1">Cycle Period:</div>
      <TauriBreadCrumbDropdown
        items={cyclePeriodItems}
        onSelect={(cyclePeriod) =>
          setSelectedDates((prev) => ({ ...prev, CycleCode: cyclePeriod }))
        }
        selectedItem={selectedDates.CycleCode}
        variant="secondary"
        id="monthDropdown"
        className="mr-3"
        placeholder="--Select Cycle Period--"
      />

      <TauriBreadCrumbDropdown
        items={yearItems}
        onSelect={(year) =>
          setSelectedDates((prev) => ({ ...prev, CycleYear: year }))
        }
        selectedItem={selectedDates.CycleYear}
        variant="secondary"
        id="yearDropdown"
        className="mr-3"
        placeholder="--Select Year--"
      />
    </>
  );
};
export default TauriCyclePeriodDropdown;
